/**
 * Color mappings for ReasonCard component
 * Used for hover states, glows, icons, and labels
 */
export const CARD_COLOR_MAP = {
  orange: {
    hover: '#f97316',
    glow: 'rgba(249, 115, 22, 0.05)',
    iconBg: 'rgba(234, 88, 12, 0.2)',
    iconColor: 'rgb(249, 115, 22)',
    label: '#fb923c',
  },
  red: {
    hover: '#ef4444',
    glow: 'rgba(239, 68, 68, 0.05)',
    iconBg: 'rgba(239, 68, 68, 0.2)',
    iconColor: '#f87171',
    label: '#f87171',
  },
  blue: {
    hover: '#3b82f6',
    glow: 'rgba(59, 130, 246, 0.05)',
    iconBg: 'rgba(59, 130, 246, 0.2)',
    iconColor: '#60a5fa',
    label: '#60a5fa',
  },
  purple: {
    hover: '#a855f7',
    glow: 'rgba(168, 85, 247, 0.05)',
    iconBg: 'rgba(168, 85, 247, 0.2)',
    iconColor: '#c084fc',
    label: '#c084fc',
  },
  green: {
    hover: '#22c55e',
    glow: 'rgba(34, 197, 94, 0.05)',
    iconBg: 'rgba(34, 197, 94, 0.2)',
    iconColor: '#4ade80',
    label: '#4ade80',
  },
}

/**
 * Get color value from map with fallback
 */
export const getCardColor = (colorKey, property, fallback) => {
  const color = CARD_COLOR_MAP[colorKey]
  return color?.[property] || fallback
}
